var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.model && _vm.model.drReport
    ? _c("div", { style: { width: _vm.width } }, [
        _c(
          "div",
          {
            staticClass: "page drReport-page",
            attrs: { id: "print_drReport" },
          },
          [
            _c("div", { staticStyle: { height: "50px" } }),
            _c("div", { staticStyle: { "font-size": "22px" } }, [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.model.drReport.hospitalName
                      ? _vm.model.drReport.hospitalName
                      : ""
                  )
                ),
              ]),
            ]),
            _c(
              "div",
              {
                staticStyle: {
                  "font-size": "17px",
                  padding: "20px 0 30px 0",
                  "font-weight": "600",
                },
              },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.model.drReport.reportName
                        ? _vm.model.drReport.reportName
                        : "DR检查报告单"
                    )
                  ),
                ]),
              ]
            ),
            _c(
              "table",
              {
                staticStyle: {
                  "margin-top": "30px",
                  "text-align": "left",
                  width: "100%",
                  "border-collapse": "collapse",
                  border: "none",
                  "border-bottom": "2px solid rgb(14, 14, 14)",
                },
              },
              [
                _c("tbody", [
                  _c(
                    "tr",
                    {
                      staticStyle: {
                        "line-height": "35px",
                        width: "100%",
                        "border-collapse": "collapse",
                        "text-align": "left",
                        border: "none",
                      },
                    },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "none",
                            width: "70%",
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticStyle: { "font-weight": "bold" } },
                            [_vm._v("检查号：")]
                          ),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.drReport.barCode
                                  ? _vm.model.drReport.barCode
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticStyle: { "font-weight": "bold" } },
                            [_vm._v("报告时间：")]
                          ),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.drReport.reportTime
                                  ? _vm.model.drReport.reportTime
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _c(
              "table",
              {
                staticStyle: {
                  "margin-top": "5px",
                  "text-align": "left",
                  width: "100%",
                  "border-collapse": "collapse",
                  border: "none",
                  "border-bottom": "2px solid rgb(14, 14, 14)",
                },
              },
              [
                _c("tbody", [
                  _c(
                    "tr",
                    {
                      staticStyle: {
                        "line-height": "35px",
                        width: "100%",
                        "border-collapse": "collapse",
                        "text-align": "left",
                        border: "none",
                      },
                    },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticStyle: { "font-weight": "bold" } },
                            [_vm._v("姓名：")]
                          ),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.drReport.name
                                  ? _vm.model.drReport.name
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticStyle: { "font-weight": "bold" } },
                            [_vm._v("性别：")]
                          ),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.drReport.sex
                                  ? _vm.model.drReport.sex
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticStyle: { "font-weight": "bold" } },
                            [_vm._v("年龄：")]
                          ),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.drReport.age
                                  ? _vm.model.drReport.age
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticStyle: { "font-weight": "bold" } },
                            [_vm._v("检查日期：")]
                          ),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.drReport.physicalTime
                                  ? _vm.model.drReport.physicalTime
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "tr",
                    {
                      staticStyle: {
                        "line-height": "35px",
                        width: "100%",
                        "border-collapse": "collapse",
                        "text-align": "left",
                        border: "none",
                      },
                    },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "none",
                          },
                          attrs: { colspan: "4" },
                        },
                        [
                          _c(
                            "span",
                            { staticStyle: { "font-weight": "bold" } },
                            [_vm._v("检查部位：")]
                          ),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.drReport.checkpoint
                                  ? _vm.model.drReport.checkpoint
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _c(
              "table",
              {
                staticStyle: {
                  "margin-top": "10px",
                  width: "100%",
                  "border-collapse": "collapse",
                  border: "none",
                },
              },
              [
                _c("tbody", [
                  _c(
                    "tr",
                    { staticStyle: { height: "200px", border: "none" } },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _c("img", {
                            staticStyle: { width: "300px", height: "250px" },
                            attrs: { src: _vm.model.drReport.imageUrl },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _c("tr", { staticStyle: { height: "30px" } }),
                  _c(
                    "tr",
                    { staticStyle: { "text-align": "left", border: "none" } },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "min-height": "200px",
                                "padding-bottom": "20px",
                              },
                            },
                            [
                              _c(
                                "p",
                                { staticStyle: { "font-weight": "bold" } },
                                [_vm._v("影像所见：")]
                              ),
                              _c("p", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.replaceString(
                                      _vm.model.drReport.modsee,
                                      "\n",
                                      "<br>"
                                    )
                                  ),
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "tr",
                    { staticStyle: { "text-align": "left", border: "none" } },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "min-height": "200px",
                                "padding-bottom": "20px",
                              },
                            },
                            [
                              _c(
                                "p",
                                { staticStyle: { "font-weight": "bold" } },
                                [_vm._v("诊断意见：")]
                              ),
                              _c("p", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.replaceString(
                                      _vm.model.drReport.moddia,
                                      "\n",
                                      "<br>"
                                    )
                                  ),
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _c(
              "table",
              {
                staticStyle: {
                  "margin-top": "30px",
                  "text-align": "left",
                  width: "100%",
                  "border-collapse": "collapse",
                  border: "none",
                  "border-bottom": "3px solid rgb(14, 14, 14)",
                },
              },
              [
                _c("tbody", [
                  _c(
                    "tr",
                    {
                      staticStyle: {
                        width: "100%",
                        "border-collapse": "collapse",
                        "text-align": "left",
                        border: "none",
                        "line-height": "30px",
                      },
                    },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "80%",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("报告医生："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.drReport.reportDoctor
                                  ? _vm.model.drReport.reportDoctor
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("签字："),
                          _vm.model.drReport.doctorSignature
                            ? _c("img", {
                                staticStyle: {
                                  height: "40px",
                                  width: "100px",
                                  "object-fit": "contain",
                                },
                                attrs: {
                                  src: _vm.model.drReport.doctorSignature,
                                },
                              })
                            : _vm._e(),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _vm._m(0),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "table",
      {
        staticStyle: {
          "text-align": "center",
          width: "100%",
          "border-collapse": "collapse",
          border: "none",
        },
      },
      [
        _c("tbody", [
          _c("tr", { staticStyle: { border: "none", "line-height": "30px" } }, [
            _c(
              "td",
              {
                staticStyle: {
                  "text-indent": "2ch",
                  "border-collapse": "collapse",
                  border: "none",
                },
              },
              [_vm._v("- 备注：本报告仅供临床医师参考，不作任何证明材料。 -")]
            ),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }